exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid--sectors[data-v-a13f971e] {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.grid--sectors [class*=col-][data-v-a13f971e] {\n  padding: 1rem;\n}", ""]);

// exports
